/**
 * Gradual Discount (Kademeli İndirim) – Cart Banner
 * ---------------------------------------------------
 * README §4.5 mesaj secme algoritmasina tam uyumlu.
 *
 * Veri kaynaklari:
 *   #discountpro-gradual-config  → shop metafield JSON
 *   #discountpro-cart-items      → cart line items (tags + qty)
 *
 * Cikti:
 *   #discountpro-gradual-banner  → gizle / goster
 *   #discountpro-gradual-msg     → mesaj icerigi
 */
(function () {
  'use strict';

  /* ── helpers ─────────────────────────────────────── */

  function parseJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /**
   * Placeholder replace.
   * Desteklenen: {remaining}, {currentQty}, {minQty}, {nextQty},
   *              {currentDiscount}, {nextDiscount}, {$percentage}, {$quantityInCart}
   */
  function replacePlaceholders(tpl, vars) {
    if (!tpl) return '';
    return tpl
      .replace(/\{remaining\}/g,        vars.remaining        != null ? vars.remaining        : '')
      .replace(/\{currentQty\}/g,        vars.currentQty       != null ? vars.currentQty       : '')
      .replace(/\{minQty\}/g,            vars.minQty           != null ? vars.minQty           : '')
      .replace(/\{nextQty\}/g,           vars.nextQty          != null ? vars.nextQty          : '')
      .replace(/\{currentDiscount\}/g,   vars.currentDiscount  != null ? vars.currentDiscount  : '')
      .replace(/\{nextDiscount\}/g,      vars.nextDiscount     != null ? vars.nextDiscount     : '')
      .replace(/\{\$percentage\}/g,      vars.currentDiscount  != null ? vars.currentDiscount  : '')
      .replace(/\{\$quantityInCart\}/g,  vars.currentQty       != null ? vars.currentQty       : '');
  }

  /**
   * <link web="..." app="...">text</link>  →  <a href="...">text</a>  (web modu)
   */
  function parseLinks(html) {
    return html.replace(
      /<link\s[^>]*web="([^"]*)"[^>]*>([\s\S]*?)<\/link>/gi,
      '<a href="$1" style="text-decoration:underline;">$2</a>'
    );
  }

  /**
   * XSS onleme: Sadece https? linklerine izin ver, diger tum icerigi escape et.
   */
  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }
  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  function safeBannerHtml(html) {
    var safeLinks = [];
    var out = html.replace(
      /<a\s+href="(https?:\/\/[^"]*)"[^>]*>([\s\S]*?)<\/a>/gi,
      function (match, href, content) {
        safeLinks.push({ href: href, content: content });
        return '___SAFE_LINK_' + (safeLinks.length - 1) + '___';
      }
    );
    out = escapeHtml(out);
    for (var i = 0; i < safeLinks.length; i++) {
      var link = safeLinks[i];
      out = out.replace(
        '___SAFE_LINK_' + i + '___',
        '<a href="' + escapeAttr(link.href) + '" style="text-decoration:underline;">' + escapeHtml(link.content) + '</a>'
      );
    }
    return out;
  }

  /* ── quantities ───────────────────────────────────── */

  /** Miktarlari DOM'dan oku (AJAX sepet guncellemesinden sonra guncel). */
  function getQuantitiesFromDOM() {
    var quantities = {};
    var items = document.querySelectorAll('[data-cart-item][data-gradual-ids]');
    for (var i = 0; i < items.length; i++) {
      var idsStr = items[i].getAttribute('data-gradual-ids');
      if (!idsStr) continue;
      var input = items[i].querySelector('[data-quantity-field]');
      var qty = input ? (parseInt(input.value, 10) || 0) : (parseInt(items[i].getAttribute('data-quantity'), 10) || 0);
      var ids = idsStr.split(',').map(function (s) { return s.trim(); });
      for (var j = 0; j < ids.length; j++) {
        var id = ids[j];
        quantities[id] = (quantities[id] || 0) + qty;
      }
    }
    return quantities;
  }

  function computeQuantitiesFromCartItems(config, cartItems) {
    var quantities = {};
    var discounts = (config && config.discounts) || [];
    for (var d = 0; d < discounts.length; d++) {
      var discountId = discounts[d].id;
      var total = 0;
      for (var i = 0; i < cartItems.length; i++) {
        var tags = cartItems[i].tags || [];
        for (var t = 0; t < tags.length; t++) {
          if (tags[t] === discountId) {
            total += cartItems[i].qty;
            break;
          }
        }
      }
      quantities[discountId] = total;
    }
    return quantities;
  }

  /* ── README §4.5 – mesaj secme algoritmasi ───────── */

  function computeMessage(tiers, currentQty) {
    if (!tiers || tiers.length === 0) return null;

    // tiers minQty artan sirada
    tiers = tiers.slice().sort(function (a, b) { return a.minQty - b.minQty; });

    var message = '';
    var remaining = 0;
    var currentTier = null;
    var nextTier = null;

    // §4.5 kural 1
    if (currentQty < tiers[0].minQty) {
      message = tiers[0].messageBefore || '';
      remaining = tiers[0].minQty - currentQty;
      nextTier = tiers[0];
    } else {
      // §4.5 kural 2 – currentTier bul
      for (var i = tiers.length - 1; i >= 0; i--) {
        if (currentQty >= tiers[i].minQty) {
          currentTier = tiers[i];
          nextTier = (i + 1 < tiers.length) ? tiers[i + 1] : null;
          break;
        }
      }

      // Tier'a tam esit mi kontrolu
      var exactlyAtTier = false;
      for (var j = 0; j < tiers.length; j++) {
        if (currentQty === tiers[j].minQty) {
          exactlyAtTier = true;
          break;
        }
      }

      if (nextTier && !exactlyAtTier) {
        // Arada: nextTier.messageBefore
        message = nextTier.messageBefore || '';
        remaining = nextTier.minQty - currentQty;
      } else {
        // Tier'a tam ulasildiysa veya max tier
        message = (currentTier && currentTier.messageWhenReached) || '';
        remaining = nextTier ? (nextTier.minQty - currentQty) : 0;
      }
    }

    // Placeholder degiskenlerini hazirla
    var vars = {
      remaining: remaining,
      currentQty: currentQty,
      minQty: currentTier ? currentTier.minQty : (tiers[0] ? tiers[0].minQty : ''),
      nextQty: nextTier ? nextTier.minQty : '',
      currentDiscount: currentTier ? currentTier.discountPct : '',
      nextDiscount: nextTier ? nextTier.discountPct : ''
    };

    message = replacePlaceholders(message, vars);
    message = parseLinks(message);

    return message || null;
  }

  /* ── render ──────────────────────────────────────── */

  function run() {
    var banner = document.getElementById('discountpro-gradual-banner');
    var msgEl  = document.getElementById('discountpro-gradual-msg');
    if (!banner || !msgEl) return;

    var config = parseJSON('discountpro-gradual-config');
    if (!config || !config.discounts || config.discounts.length === 0) {
      banner.style.display = 'none';
      return;
    }

    var quantities = getQuantitiesFromDOM();
    if (Object.keys(quantities).length === 0) {
      var cartItems = parseJSON('discountpro-cart-items');
      if (cartItems) quantities = computeQuantitiesFromCartItems(config, cartItems);
    }

    // Tum aktif discount'lar icin mesaj uret – ilk dolunun mesajini goster
    var finalMessage = null;
    for (var d = 0; d < config.discounts.length; d++) {
      var disc = config.discounts[d];
      var qty  = quantities[disc.id] || 0;
      if (qty < 1) continue; // sepette urun yok → bu discount icin banner gosterme

      var msg = computeMessage(disc.tiers, qty);
      if (msg) {
        finalMessage = msg;
        break; // ilk eslesen discount'in mesajini goster
      }
    }

    if (finalMessage) {
      var text = finalMessage.replace(/\\n/g, '\n');
      var firstNewline = text.indexOf('\n');
      var title = firstNewline >= 0 ? text.slice(0, firstNewline) : text;
      var rest = firstNewline >= 0 ? text.slice(firstNewline + 1) : '';
      var restHtml = rest ? rest.split('\n').map(function (line) { return safeBannerHtml(line); }).join('<br>') : '';
      msgEl.innerHTML = '<span class="gradual-banner-title">' + safeBannerHtml(title) + '</span>' + (restHtml ? '<br>' + restHtml : '');
      banner.style.display = '';
    } else {
      banner.style.display = 'none';
    }
  }

  /* ── init ────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // theme:cart:added → build() tamamlandiktan sonra ateslenir (DOM guncel)
  document.addEventListener('theme:cart:added', function () {
    setTimeout(run, 50);
  });
  document.addEventListener('cart:refresh', run);
})();
